"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var routes_1 = require("../config/routes");
var api_1 = require("../libs/api");
exports.getChangelogs = function (token) {
    return api_1.default.get(routes_1.GET_CHANGELOGS, {
        headers: {
            "WIDGET-KEY": token,
        },
    });
};
exports.getChangelog = function (token, changelogId) {
    return api_1.default.get(routes_1.GET_CHANGELOG(changelogId), {
        headers: {
            "WIDGET-KEY": token,
        },
    });
};
